/* eslint-disable */
import { forwardRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { isIosTouchDevice, recoverIosViewportScale, resetIosFocusScroll } from '../../utils/iosInputZoom';
import './StationListSearch.css';

const StationListSearch = forwardRef(function StationListSearch({ value, onChange }, ref) {
  const { t } = useTranslation();

  const handleFocus = useCallback(() => {
    if (!isIosTouchDevice()) return;
    resetIosFocusScroll();
    requestAnimationFrame(resetIosFocusScroll);
  }, []);

  const handleBlur = useCallback(() => {
    if (!isIosTouchDevice()) return;
    recoverIosViewportScale();
    window.setTimeout(recoverIosViewportScale, 50);
    window.setTimeout(recoverIosViewportScale, 300);
  }, []);

  return (
    <div className="station-list-search-wrap">
      <input
        ref={ref}
        className="station-list-search-input"
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        enterKeyHint="search"
        autoComplete="off"
        autoCorrect="off"
        spellCheck={false}
        placeholder={t('stationListSearchPlaceholder')}
        aria-label={t('stationListSearchPlaceholder')}
        value={value}
        onChange={event => onChange(event.target.value)}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
    </div>
  );
});

export default StationListSearch;
